import { GlButton } from '@gitlab/ui';
export default {
    name: 'SidebarFormattedDate',
    components: {
        GlButton
    },
    inject: [
        'canUpdate'
    ],
    props: {
        formattedDate: {
            required: true,
            type: String
        },
        hasDate: {
            required: true,
            type: Boolean
        },
        resetText: {
            required: true,
            type: String
        },
        isLoading: {
            required: true,
            type: Boolean
        },
        canDelete: {
            required: false,
            type: Boolean,
            default: true
        }
    },
    emits: [
        'reset-date'
    ]
};
